/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect, createRef } from 'react';

import PropTypes from 'prop-types';
import Spinner from '@tds/core-spinner';
import Tabs from '@tds/community-tabs';
import axios from 'axios';
import { Image, Error } from '../design/elements';
import RichText from '../richText';
import FormStep from './formStep';
import FormStepWLS from './formStepWLS';
import FormStepBRP from './formStepBRP';
import FormStepFM from './formStepFM';
import FormStepOCDR from './formStepOCDR';
import FormStepVulcan from './formStepVulcan';
import { FormWrapper } from './css';
import HardwareGridUpload from '../HardwareGridUpload';
import { updatePayloadIfEasyPaymentsShouldHide } from '../../helpers/orders';
import {
  wlsSubmitPayload,
  brpSubmitPayload,
  submitPayload,
  saveAndExit,
  saveAndContinue,
  fmSubmitPayload,
  ocdrSubmitPayload,
  vulcanSubmitPayload,
  fmSOWSubmitPayload
} from './formSubmitLogic';
import SrtDashboard from '../srtDashboard';
import MyOrdersDashboardFM from '../myOrdersDashboardFM';
import MyOrdersDashboardOCDR from '../myOrdersDashboardOCDR';
import OrderFulfillmentDashboardOCDR from '../orderFulfillmentDashboardOCDR';
import MyOrdersDashboardVUL from '../myOrdersDashboardVUL';
import MyOrdersDashboardFMSOW from '../myOrdersDashboardFMSOW';
import SalesRepDashboard from '../salesRepDashboard';
import OrderFulfillmentDashboard from '../orderFulfillmentDashboard';
import OrderFulfillmentDashboardFM from '../orderFulfilmentDashboardFM';
import OrderFulfillmentDashboardVUL from '../orderFulfillmentDashboardVUL';
import OrderFulfillmentDashboardFMSOW from '../orderFulfilmentDashboardFMSOW';
import DiscountApprovalDashboardFM from '../discountApprovalDashboardFM';
import AllOrdersDashboardWLS from '../allOrdersDashboardWLS';
import ChannelOrdersDashboardWLS from '../channelOrdersDashboardWLS';
import BrpConfirmationBox from './BRP/BrpConfirmationBox';

import {
  orderDetailsForm,
  orderSummaryForm,
  landingPageForm,
  wirelessLandingPageForm,
  wirelessOrderForm,
  quoteToolForm,
  fieldProductSelection,
  valueCustomerInformation,
  valueProductInformation,
  BACKEND_KEYS,
  orderStatus,
  keySalesOrderChecklist,
  keyOrderCustomerInformation,
  keyWinbackInstallationOrderStep,
  keyOrderSummary,
  productValuesToBackendKeys,
  keyOrderSummaryForm,
  categoryWireless,
  DevicesOnlyEnglish,
  DevicesOnlyFrench,
  AccessoriesOnlyEnglish,
  AccessoriesOnlyFrench,
  categoryBrp,
  brpPrequalification,
  brpOrderForm,
  categoryWireline,
  fieldSecureBusiness,
  sevenX,
  categoryFullyManaged,
  fullyManagedForm,
  fullyManagedLandingPage,
  categoryVulcan,
  vulcanForm,
  vulcanLandingPage,
  fieldBusinessConnectVulcan,
  categoryFullyManagedSOW,
  fullyManagedSOWForm,
  fullyManagedSOWLandingPage,
  emailForSOW,
  categoryOCDR,
  ocdrForm,
  ocdrLandingPage,
  fieldMicrosoftCloudAndAdvisoryServices
} from '../utils/constant';
import EN from '../../EN.json';
import FR from '../../FR.json';
import request, { apiHost, config } from '../utils/request';
import { getPathVariables } from '../misc';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { useLocaleContext } from '../context/LocaleContext';
import FormStepFMSOW from './formStepFMSOW';

const Form = ({ data, orderId, history, initialStep, isEditing, dataSummary }) => {
  if (!data) return <Error text="Error!" />;

  const {
    fields: {
      image,
      description,
      steps,
      skipIntro,
      hideProgressBar,
      showOrdersList
    }
  } = data;
  const local = useLocaleContext();

  const localizedStrings = useLocalizedStringsContext();
  const {
    WLS: {
      TABS: { MyOrders, AllOrders, ChannelOrders }
    }
  } = localizedStrings;
  const {
    formButtons: {
      newQuoteButtonLabel,
      ManageDevicesCreditsFee,
      newOrderButtonLabel,
      WirelineandSecureBusiness,
      TELUSWirelessSalesOrderForm
    },
    vulcanWebform: { vulBusinessConnect },
    dashboardVUL: { myOrderHeader, orderFulfilmentHeader }
  } = local === 'en-US' ? EN : FR;
  const [step, setStep] = useState(
    (initialStep && parseInt(initialStep, 10)) || (skipIntro ? 1 : 0)
  );
  const [stepData, setStepData] = useState();
  const [progressBarSteps, setProgressBarSteps] = useState([]);
  const [orderPermissions, setOrderPermissions] = useState([]);
  const [orderData, setOrderData] = useState();
  const [formRef, setFormRef] = useState(createRef());
  const [showLoading, setShowLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isCreateOrderButtonVisible, setIsCreateOrderButtonVisible] = useState(false);
  const [selectedDiscount, setSelectedDiscount] = useState(null);

  let quoteSummaryData;
  const {
    location: { pathname, search }
  } = history;
  const [locale, categoryName, formName] = getPathVariables(pathname);

  const userProfile = JSON.parse(localStorage.getItem('userProfile'));
  const { role: { name: roleName = '' } = {}, channel, email } =
    userProfile || {};
  const isChannelSevenX = channel && channel.name === sevenX;

  const [activeTab, setActiveTab] = useState(
    roleName === 'ORDER_FULFILLMENT' ? 'OrderFulfillmentDashboard' : 'MyOrders'
  );

  useEffect(()=>{
    const params = new URLSearchParams(search);
    const discount = params.get("discount");
    if(discount) {
      setSelectedDiscount(discount);
      setActiveTab('DiscountApprovalDashboard');
    } else {
      setSelectedDiscount(null);
    }
  }, []);

  useEffect(() => {
    if (showOrdersList) {
      setOrderData(undefined);
    }
  }, [showOrdersList]);

  const getLocaleLocalValues = () => {
    if (locale === 'fr-CA') return FR;
    return EN;
  };

  const getToolPath = () => {
    if (categoryName === categoryWireline)
      return `/${locale}/wireline_and_secure_business/Landing_Page`;
    if (categoryName === categoryWireless)
      return `/${locale}/wireless/Wireless_Landing_Page?page=1`;
    if (categoryName === categoryFullyManaged) {
      return `/${locale}/fully_managed/Fully_Managed_Landing_Page?page=1`;
    }
    if (categoryName === categoryVulcan) {
      return `/${locale}/vulcan/Vulcan_Landing_Page?page=1`;
    }
    if (categoryName === categoryFullyManagedSOW) {
      return `/${locale}/fully_managed_SOW/Fully_Managed_SOW_Landing_Page?page=1`;
    }
    if (categoryName === categoryOCDR) {
      return `/${locale}/ocdr/OCDR_Landing_Page?page=1`;
    }
    return '/';
  };

  const {
    WLS: {
      WIRELESS_ORDER_DETAILS: {
        StepNameVariations: {
          WirelessOrderDetails,
          DeviceOrderDetails,
          AccessoryOrderDetails
        }
      }
    }
  } = getLocaleLocalValues();

  const isCreateOrderVisible = formName === quoteToolForm;

  const setQuoteSummaryData = quoteData => {
    quoteSummaryData = quoteData;
  };

  const updateStep = newStep => {
    setStep(newStep);
  };

  const updateProgressBarSteps = productSelection => {
    if (formName !== orderDetailsForm) {
      let result = steps.filter(item =>
        [valueCustomerInformation, valueProductInformation].includes(
          item.fields.backendKey
        )
      );
      if (productSelection && productSelection.length) {
        result = [
          ...result,
          ...productSelection.map(item => ({
            fields: { name: item }
          }))
        ];
      }
      const quoteSummaryStep = steps.find(
        stepForm => stepForm.fields.backendKey === BACKEND_KEYS.quoteSummary
      );
      if (quoteSummaryStep) {
        result = [...result, quoteSummaryStep];
      }
      setProgressBarSteps(result);
    } else {
      let result = steps.filter(item =>
        [keySalesOrderChecklist, keyOrderCustomerInformation].includes(
          item.fields.backendKey
        )
      );

      if (productSelection && productSelection.length) {
        result = [
          ...result,
          ...steps.filter(stepItem =>
            productSelection.some(
              item =>
                productValuesToBackendKeys[item] === stepItem.fields.backendKey
            )
          )
        ];
      }

      result = [
        ...result,
        ...steps.filter(item =>
          [
            keyWinbackInstallationOrderStep,
            keyOrderSummaryForm,
            keyOrderSummary
          ].includes(item.fields.backendKey)
        )
      ];

      setProgressBarSteps(result);
    }
  };

  const fetchOrderPermissions = async () => {
    try {
      const result = await request.get('/order-permissions-dates');
      if (result && result.status === 200) {
        setOrderPermissions(result.data.data);
      }
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    fetchOrderPermissions();
  }, []);

  useEffect(() => {
    if (orderId) {
      if (categoryName === categoryWireless) {
        axios.get(`${apiHost}/orders/${orderId}`, config()).then(response => {
          if (response && response.data) {
            setOrderData(response.data);
            updateProgressBarSteps(response.data[fieldProductSelection]);
          }
        });
      } else {
        const api = categoryName === categoryBrp ? 'brp' : 'orders';
        request.get(`/${api}/${orderId}`).then(response => {
          if (response && response.data) {
            setOrderData(response.data);
            updateProgressBarSteps(response.data[fieldProductSelection]);
          }
        });
      }
    } else {
      updateProgressBarSteps();
    }
  }, [orderId]);
  /**
   * Whenever locale changes, following code updates the stepData and progressBarSteps
   * acccordingly
   */
  useEffect(() => {
    let result;
    if (
      categoryName === categoryWireless ||
      categoryName === categoryFullyManaged ||
      categoryName === categoryFullyManagedSOW ||
      categoryName === categoryOCDR ||
      categoryName === categoryVulcan
    ) {
      setStepData(steps[step - 1]);
    } else {
      if (progressBarSteps && progressBarSteps.length > 0) {
        if (step === 2 && formName === quoteToolForm) {
          updateProgressBarSteps([]);
        } else if (orderData && orderData.productSelection) {
          if (
            !(
              stepData &&
              stepData.fields &&
              stepData.fields.backendKey === BACKEND_KEYS.quoteSummary &&
              formName === orderDetailsForm
            )
          ) {
            updateProgressBarSteps(orderData.productSelection);
          }
        }
        if (progressBarSteps[step - 1]) {
          const stepName = progressBarSteps[step - 1].fields.name;
          result = steps.find(item => item.fields.name === stepName);
        }
      } else {
        result = steps[step - 1];
      }
      if (
        !(
          stepData &&
          stepData.fields &&
          stepData.fields.backendKey === BACKEND_KEYS.quoteSummary &&
          formName === orderDetailsForm
        )
      ) {
        setStepData(result);
      }
    }
  }, [data, step, orderData]);

  const updateStepData = () => {
    let result;
    if (progressBarSteps[step - 1]) {
      const stepName = progressBarSteps[step - 1].fields.name;
      result = steps.find(item => item.fields.name === stepName);
    } else {
      result = steps[step - 1];
    }
    setStepData(result);
  };

  useEffect(() => {
    if (progressBarSteps && formName !== wirelessLandingPageForm) {
      updateStepData();
    }
  }, [progressBarSteps]);

  useEffect(() => {
    if (formName !== wirelessLandingPageForm) {
      updateStepData();
    }
  }, [step]);

  const showQuoteButton = () => {
    if (roleName === 'ORDER_FULFILLMENT') {
      return false;
    }
    if (roleName === 'SALES_MANAGER' && categoryName === categoryFullyManaged) {
      return false;
    }
    return true;
  };

  const fileAlreadyExists = (orderPayload, newKey) =>
    orderPayload.files.some(item => Object.keys(item) === newKey);

  const attachedFiles = (orderPayload, formData) => {
    if ([1, 5].includes(step)) {
      if (orderPayload && orderPayload.files) {
        if (formData.files && formData.files && formData.files.length) {
          formData.files.forEach(item => {
            if (!fileAlreadyExists(orderPayload, Object.keys(item))) {
              orderPayload.files.push(item);
            }
          });
        }
      }
    }
    return orderPayload;
  };

  const onWlsFormSubmit = async (formData, isFormLastStep) => {
    let newStep;
    if (formName === wirelessLandingPageForm) {
      newStep = isChannelSevenX ? 2 : 1;
    } else {
      newStep = step + 1;
    }
    const searchString = (paramStep, id = '') => {
      return orderData && orderData.id
        ? `?orderId=${orderData.id}&step=${paramStep}&isEditing=true`
        : `?orderId=${id}&step=${paramStep}&isEditing=true`;
    };
    let response = {};
    // SOF-1545
    if (orderData && orderData.smbIndirectChannelSalesRep) {
      const updatedChannelName = orderData.smbIndirectChannelSalesRep;
      orderData.loggedInUserDetail.channelName = updatedChannelName;
    }
    if (step === 1 || step === 4) {
      // Send order data to API
      response = await wlsSubmitPayload(
        {
          ...orderData,
          ...formData,
          locale,
          categoryName,
          formName,
          step: newStep
        },
        isFormLastStep,
        orderPermissions
      );
    } else {
      // Send order data to API
      const tempOrderData = attachedFiles(orderData, formData);
      response = await wlsSubmitPayload(
        {
          ...tempOrderData,
          ...formData,
          locale,
          categoryName,
          formName,
          step: newStep
        },
        isFormLastStep,
        orderPermissions
      );
    }
    setOrderData({ ...orderData, ...response.data });
    if (response) {
      if (formName === wirelessLandingPageForm && step === 1 && !orderData) {
        updateStep(1);
        history.push({
          pathname: `/${locale}/${categoryName}/${wirelessOrderForm}`,
          search: searchString(isChannelSevenX ? 2 : 1, response.data.id)
        });
        window.location.reload();
      } else if (step >= steps.length) {
        /*
         * Logic for redirecting to Wireless home page after user hits Submit
         * button on Summary page
         */
        history.push({
          pathname: `/${locale}/${categoryName}/${wirelessLandingPageForm}`
        });
        window.location.reload();
      } else {
        updateStep(newStep);
        history.push({
          pathname: `/${locale}/${categoryName}/${wirelessOrderForm}`,
          search: searchString(newStep, response.data.id)
        });
      }
    }
  };

  const onFMFormSubmit = async (
    formData,
    shouldUpdateStep = true,
    isFormLastStep
  ) => {
    const newStep = step + 1;
    const searchString = (paramStep, id = '') => {
      return orderData && orderData.id
        ? `?orderId=${orderData.id}&step=${paramStep}&isEditing=true`
        : `?orderId=${id}&step=${paramStep}&isEditing=true`;
    };
    let response = {};
    // Send order data to API
    const tempOrderData = attachedFiles(orderData, formData);
    response = await fmSubmitPayload(
      {
        ...tempOrderData,
        ...formData,
        locale,
        categoryName,
        formName,
        step: newStep
      },
      isFormLastStep
    );
    setOrderData({ ...orderData, ...response.data });
    if (response && shouldUpdateStep) {
      if (formName === fullyManagedLandingPage && step === 1 && !orderData) {
        updateStep(1);
        history.push({
          pathname: `/${locale}/${categoryName}/${fullyManagedForm}`,
          search: searchString(1, response.data.id)
        });
      } else if (step >= steps.length) {
        /*
         * Logic for redirecting to Wireless home page after user hits Submit
         * button on Summary page
         */
        history.push({
          pathname: `/${locale}/${categoryName}/${fullyManagedLandingPage}`
        });
        window.location.reload(); // remove this and add API call instead
      } else {
        updateStep(newStep);
        history.push({
          pathname: `/${locale}/${categoryName}/${fullyManagedForm}`,
          search: searchString(newStep, response.data.id)
        });
      }
    }
  };

  const onVulcanFormSubmit = async (
    formData,
    shouldUpdateStep = true,
    isFormLastStep
  ) => {
    let newStep;
    if (
      formData.addProductVulcan &&
      formData.addProductVulcan.includes(vulBusinessConnect) &&
      step === 1
    ) {
      newStep = step + 2;
    } else if (formData && formData.orderIdTSB && step === 1) {
      newStep = step + 2;
    } else {
      newStep = step + 1;
    }

    // const newStep = step + 1;
    const searchString = (paramStep, id = '') => {
      return orderData && orderData.id
        ? `?orderId=${orderData.id}&step=${paramStep}&isEditing=true`
        : `?orderId=${id}&step=${paramStep}&isEditing=true`;
    };
    let response = {};
    // Send order data to API
    const tempOrderData = attachedFiles(orderData, formData);
    response = await vulcanSubmitPayload(
      {
        ...tempOrderData,
        ...formData,
        locale,
        categoryName,
        formName,
        step: newStep
      },
      isFormLastStep
    );
    setOrderData({ ...orderData, ...response.data });
    if (response && shouldUpdateStep) {
      if (formName === vulcanLandingPage && step === 1 && !orderData) {
        updateStep(1);
        history.push({
          pathname: `/${locale}/${categoryName}/${vulcanForm}`,
          search: searchString(1, response.data.id)
        });
      } else if (step >= steps.length) {
        /*
         * Logic for redirecting to Wireless home page after user hits Submit
         * button on Summary page
         */
        history.push({
          pathname: `/${locale}/${categoryName}/${vulcanLandingPage}`
        });
        window.location.reload(); // remove this and add API call instead
      } else {
        updateStep(newStep);
        history.push({
          pathname: `/${locale}/${categoryName}/${vulcanForm}`,
          search: searchString(newStep, response.data.id)
        });
      }
    }
  };

  const onFMFormSubmitSOW = async (
    formData,
    shouldUpdateStep = true,
    isFormLastStep
  ) => {
    let newStep;
    if (formData.appendicesIncluded) {
      if (formData.appendicesIncluded === 'No') {
        newStep = step + 2;
      } else {
        newStep = step + 1;
      }
    } else if (orderData && orderData.appendicesIncluded) {
      if (orderData.appendicesIncluded === 'No') {
        newStep = step + 2;
      } else {
        newStep = step + 1;
      }
    }

    const searchString = (paramStep, id = '') => {
      return orderData && orderData.id
        ? `?orderId=${orderData.id}&step=${paramStep}&isEditing=true`
        : `?orderId=${id}&step=${paramStep}&isEditing=true`;
    };
    let response = {};
    // Send order data to API
    const tempOrderData = attachedFiles(orderData, formData);
    response = await fmSOWSubmitPayload(
      {
        ...tempOrderData,
        ...formData,
        locale,
        categoryName,
        formName,
        step: newStep
      },
      isFormLastStep
    );
    setOrderData({ ...orderData, ...response.data });
    if (response && shouldUpdateStep) {
      if (formName === fullyManagedSOWLandingPage && step === 1 && !orderData) {
        updateStep(1);
        history.push({
          pathname: `/${locale}/${categoryName}/${fullyManagedSOWForm}`,
          search: searchString(1, response.data.id)
        });
      } else if (step >= steps.length) {
        /*
         * Logic for redirecting to Wireless home page after user hits Submit
         * button on Summary page
         */
        history.push({
          pathname: `/${locale}/${categoryName}/${fullyManagedSOWLandingPage}`
        });
        window.location.reload(); // remove this and add API call instead
      } else {
        updateStep(newStep);
        history.push({
          pathname: `/${locale}/${categoryName}/${fullyManagedSOWForm}`,
          search: searchString(newStep, response.data.id)
        });
      }
    }
  };

  const onOCDRFormSubmit = async (
    formData,
    shouldUpdateStep = true,
    isFormLastStep
  ) => {
    let newStep;
    if (formData.productSelectionOCDR) {
      if (!formData.productSelectionOCDR.includes(fieldMicrosoftCloudAndAdvisoryServices)) {
        newStep = step + 2;
      } else {
        newStep = step + 1;
      }
    } else if (orderData && orderData.productSelectionOCDR) {
      if (!orderData.productSelectionOCDR.includes(fieldMicrosoftCloudAndAdvisoryServices)) {
        newStep = step + 2;
      } else {
        newStep = step + 1;
      }
    }

    const searchString = (paramStep, id = '') => {
      return orderData && orderData.id
        ? `?orderId=${orderData.id}&step=${paramStep}&isEditing=true`
        : `?orderId=${id}&step=${paramStep}&isEditing=true`;
    };
    let response = {};
    const salesRepInfoForSRT = JSON.parse(
      localStorage.getItem('salesRepInfoForSRT')
    );
    const profileOfSalesRep = salesRepInfoForSRT;
    if (profileOfSalesRep) {
      delete profileOfSalesRep.id;
      delete profileOfSalesRep.province;
      delete profileOfSalesRep.status;
      delete profileOfSalesRep.createdAt;
      delete profileOfSalesRep.updatedAt;
      profileOfSalesRep.channelId = _.get(profileOfSalesRep,'channels.0.id', '')
    }
    // Send order data to API
    const tempOrderData = attachedFiles(orderData, formData);
    response = await ocdrSubmitPayload(
      {
        ...tempOrderData,
        ...formData,
        locale,
        categoryName,
        formName,
        step: newStep,
        ...(salesRepInfoForSRT ? profileOfSalesRep : {})
      },
      isFormLastStep
    );
    setOrderData({ ...orderData, ...response.data });
    if (response && shouldUpdateStep) {
      if (formName === ocdrLandingPage && step === 1 && !orderData) {
        updateStep(1);
        history.push({
          pathname: `/${locale}/${categoryName}/${ocdrForm}`,
          search: searchString(1, response.data.id)
        });
      } else if (step >= steps.length) {
        /*
         * Logic for redirecting to Wireless home page after user hits Submit
         * button on Summary page
         */
        history.push({
          pathname: `/${locale}/${categoryName}/${ocdrLandingPage}`
        });
        window.location.reload(); // remove this and add API call instead
      } else {
        updateStep(newStep);
        history.push({
          pathname: `/${locale}/${categoryName}/${ocdrForm}`,
          search: searchString(newStep, response.data.id)
        });
      }
    }
  };

  const handleSubmitAnotherBrpRequest = () => {
    updateStep(1);
    setShowConfirmation(false);
    setOrderData(null);
    history.push(`/${locale}/${categoryBrp}/${brpPrequalification}`);
  };

  const onBrpFormSubmit = async formData => {
    setShowLoading(true);
    const newStep = formName === brpPrequalification ? 1 : step + 1;
    const isLastStep = step === steps.length;

    const searchString = (paramStep, id = '') => {
      return orderData && orderData.id
        ? `?orderId=${orderData.id}&step=${paramStep}&isEditing=true`
        : `?orderId=${id}&step=${paramStep}&isEditing=true`;
    };
    // Send order data to API
    const response = await brpSubmitPayload(
      {
        ...orderData,
        ...formData,
        locale,
        categoryName,
        formName,
        step: newStep
      },
      isLastStep
    );

    if (response) {
      if (formName === brpPrequalification && step === 1 && !orderData) {
        updateStep(1);
        history.push({
          pathname: `/${locale}/${categoryName}/${brpOrderForm}`,
          search: searchString(1, response.data.id)
        });
        // window.location.reload();
      } else if (formName === brpOrderForm && isLastStep) {
        setShowConfirmation(true);
      } else {
        updateStep(newStep);
        history.push({
          pathname: `/${locale}/${categoryName}/${brpOrderForm}`,
          search: searchString(newStep, response.data.id)
        });
      }
      setOrderData({
        ...orderData,
        ...response.data
      });
      setShowLoading(false);
    }
  };

  const onFormSubmit = async (formData, isFormLastStep, isOrderLastStep, isCuponCodeSubmit) => {
    // Finish the flow
    if (formName === landingPageForm && step === 1 && !orderData) {
      updateStep(0);
      // const searchString = `?step=1`;
      // history.push({
      //   pathname: `/${locale}/${categoryName}/${quoteToolForm}`,
      //   search: searchString
      // });
      // window.location.reload();
      onSaveAndContinue(formData, 1);
    } else {
      const isQuoteFinalStep =
        formName === landingPageForm && step === 1 && orderData && orderData.id;
      const updatedStep = isQuoteFinalStep ? 1 : step;
      const putPayload = {
        ...orderData,
        ...formData,
        locale,
        categoryName,
        formName,
        step: updatedStep
      };
      if (isFormLastStep) {
        putPayload.products = quoteSummaryData;
        putPayload.step = 1;
      }

      if (
        !isFormLastStep &&
        (!putPayload.activationLanguage || !putPayload.province)
      ) {
        // eslint-disable-next-line no-alert
        window.alert(
          'activation language or province is missing in the payload'
        );
        window.location.reload();
      }
      const response = await submitPayload(
        putPayload,
        isFormLastStep || isOrderLastStep,
        isCuponCodeSubmit
      );
      setOrderData({ ...orderData, ...response.data });
      const newOrderId = response.data.id;
      if (isOrderLastStep) {
        history.push({
          pathname: `/${locale}/${categoryName}/${landingPageForm}`
        });
        window.location.reload();
      }
      if (formName === landingPageForm && step === 1 && newOrderId) {
        let searchString = `?orderId=${newOrderId}`;
        if (isEditing) {
          searchString = `?orderId=${newOrderId}&step=1&isEditing=true`;
        }
        updateStep(0);
        history.push({
          pathname: `/${locale}/${categoryName}/${quoteToolForm}`,
          search: searchString
        });
      } else if (formName === orderDetailsForm && step === 6 && newOrderId) {
        updateStep(1);
        history.push({
          pathname: `/${locale}/${categoryName}/${orderSummaryForm}`,
          search: `?orderId=${newOrderId}`
        });
      } else if (formName === orderSummaryForm && step === 1 && newOrderId) {
        updateStep(1);
        setOrderData();
        const redirectUrl = getToolPath();
        history.push({
          pathname: redirectUrl
        });
      }
    }
  };

  // Downlad PDF
  const viewPDF = () => {
    const { id } = orderData;
    saveAndExit(orderData);
    window.open(`${apiHost}/orders/${id}/proposal-pdf?lang=${locale}`, '_blank');
  };

  const onCreateOrder = async formData => {
    const salesRepInfoForSRT = JSON.parse(
      localStorage.getItem('salesRepInfoForSRT')
    );
    const profileOfSalesRep = salesRepInfoForSRT;
    if (categoryName === categoryWireline) {
      if (profileOfSalesRep) {
        delete profileOfSalesRep.id;
        delete profileOfSalesRep.province;
        delete profileOfSalesRep.status;
        delete profileOfSalesRep.createdAt;
        delete profileOfSalesRep.updatedAt;
        profileOfSalesRep.channelId = _.get(
          profileOfSalesRep,
          'channels.0.id',
          ''
        );
        profileOfSalesRep.firstNameSalesRep = profileOfSalesRep.firstName;
        profileOfSalesRep.lastNameSalesRep = profileOfSalesRep.lastName;
        delete profileOfSalesRep.firstName;
        delete profileOfSalesRep.lastName;
      }
      localStorage.removeItem('salesRepInfoForSRT');
    }

    const response = await submitPayload({
      ...formData,
      locale,
      categoryName,
      formName,
      step,
      ...(salesRepInfoForSRT && categoryName === categoryWireline
        ? profileOfSalesRep
        : {})
    });
    return (response && response.data) || null;
  };
  const onSaveAndExit = async (formData, shouldExit = true) => {
    if (step === 1 && !orderId && !orderData) {
      const newOrderData = await onCreateOrder(formData);
      if (newOrderData) {
        const redirectUrl = getToolPath();
        history.push({
          pathname: redirectUrl
        });
      }
    } else {
      const putPayload = {
        ...orderData,
        ...formData,
        locale,
        categoryName,
        formName,
        step
      };
      if (formName === orderDetailsForm && step === 1) {
        putPayload.status = orderStatus.newOrder;
      }
      let updatedPayload = putPayload;
      if (step === 2 && formName === quoteToolForm) {
        updatedPayload = updatePayloadIfEasyPaymentsShouldHide(putPayload);
      }
      saveAndExit(updatedPayload, shouldExit);
    }
  };

  const onSaveAndContinue = async (formData, stepOverride ) => {
    if (step === 1 && !orderId && !orderData) {
      const newOrderData = await onCreateOrder(formData, step);
      if (newOrderData) {
        setOrderData({ ...newOrderData });
        const newOrderId = newOrderData.id;
        const searchString = `?orderId=${newOrderId}&step=${stepOverride ? stepOverride : step +
          1}&isEditing=true`;
        let newLocale = locale;
        if (
          newOrderData.typeOfOrder === 'WLN' &&
          (localStorage.getItem('province') === 'AB' ||
            localStorage.getItem('province') === 'BC')
        ) {
          newLocale = 'en-US';
        }
        history.push({
          pathname: `/${newLocale}/${categoryName}/${quoteToolForm}`,
          search: searchString
        });
        window.location.reload();
      } else {
        const redirectUrl = getToolPath();
        history.push({
          pathname: redirectUrl
        });
      }
    } else {
      const putPayload = {
        ...orderData,
        ...formData,
        locale,
        categoryName,
        formName,
        step
      };
      if (formName === orderDetailsForm && step === 1) {
        putPayload.status = orderStatus.newOrder;
      }
      let updatedPayload = putPayload;
      if (step === 2 && formName === quoteToolForm) {
        updatedPayload = updatePayloadIfEasyPaymentsShouldHide(putPayload);
      }
      const req = await saveAndContinue(updatedPayload);
      const isTSB =
        updatedPayload.productSelection &&
        updatedPayload.productSelection.length > 0 &&
        updatedPayload.productSelection.includes(fieldSecureBusiness);
      const provinceAlias =
        localStorage.getItem('province') === 'AB' ||
        localStorage.getItem('province') === 'BC';
      if (req && req.data) {
        if (step === 2 && isTSB && !provinceAlias) {
          window.location.reload();
        }
        const newOrderData =
          (req && req.data) || (orderData && { ...orderData });
        return newOrderData;
      }
    }
    return orderData;
  };

  const onClick = e => {
    e.preventDefault();
    if (typeof formRef.dispatchEvent === 'function') {
      formRef.dispatchEvent(new Event('submit'));
    } else {
      updateStep(1);
    }
  };

  const onCreateNewOrder = e => {
    e.preventDefault();
    if (orderData) {
      const { id: orderID } = orderData;

      const searchString = `?orderId=${orderID}&step=1&isEditing=true`;
      history.push({
        pathname: `/${locale}/${categoryName}/${orderDetailsForm}`,
        search: searchString
      });
      window.location.reload();
    } else {
      const redirectUrl = getToolPath();
      history.push({
        pathname: redirectUrl
      });
    }
  };

  if (!stepData) return null;

  const stepsCopy = steps;
  // rename 4th step to Device Order Details in case of devices only
  if (
    orderData &&
    orderData.orderNotEligibleforMssReason &&
    (orderData.orderNotEligibleforMssReason.includes(DevicesOnlyEnglish) ||
      orderData.orderNotEligibleforMssReason.includes(DevicesOnlyFrench))
  ) {
    const stepName = WirelessOrderDetails;
    const result = steps.find(item => item.fields.name === stepName);
    if (result && result.fields && result.fields.name) {
      result.fields.name = DeviceOrderDetails;
      steps[3] = result;
      steps.splice(4, 1);
    }
  } else {
    const stepName = DeviceOrderDetails;
    const result = steps.find(item => item.fields.name === stepName);
    if (result && result.fields && result.fields.name) {
      result.fields.name = WirelessOrderDetails;
      steps[3] = result;
      steps.splice(2, 0, stepsCopy[4]);
    }
  }

  // rename 4th step to Accessory Order Details in case of devices only
  if (
    orderData &&
    orderData.orderNotEligibleforMssReason &&
    (orderData.orderNotEligibleforMssReason.includes(AccessoriesOnlyEnglish) ||
      orderData.orderNotEligibleforMssReason.includes(AccessoriesOnlyFrench))
  ) {
    const stepName = WirelessOrderDetails;
    const result = steps.find(item => item.fields.name === stepName);
    if (result && result.fields && result.fields.name) {
      result.fields.name = AccessoryOrderDetails;
      steps[3] = result;
      steps.splice(4, 1);
    }
  } else {
    const stepName = AccessoryOrderDetails;
    const result = steps.find(item => item.fields.name === stepName);
    if (result && result.fields && result.fields.name) {
      result.fields.name = WirelessOrderDetails;
      steps[3] = result;
      steps.splice(2, 0, stepsCopy[4]);
    }
  }

  const getFormStep = () => {
    if (categoryName === categoryBrp)
      return (
        <Spinner
          label={<span>Saving Data...</span>}
          spinning={showLoading}
          fullScreen
        >
          <FormStepBRP
            setQuoteSummaryData={setQuoteSummaryData}
            stepData={stepData}
            steps={steps}
            progressBarSteps={progressBarSteps}
            step={step}
            updateStep={updateStep}
            history={history}
            orderData={orderData}
            onSaveAndExit={onSaveAndExit}
            onViewPdf={viewPDF}
            onFormSubmit={onBrpFormSubmit}
            setFormRef={setFormRef}
            hideProgressBar={hideProgressBar}
            setOrderData={setOrderData}
            isEditing={isEditing}
            formName={formName}
            onSaveAndContinue={onSaveAndContinue}
            onCreateNewOrder={onCreateNewOrder}
            isCreateOrderVisible={isCreateOrderVisible}
          />
          {showConfirmation && (
            <BrpConfirmationBox
              handleSubmitAnotherBrpRequest={handleSubmitAnotherBrpRequest}
            />
          )}
        </Spinner>
      );
    if (categoryName === categoryWireless)
      return (
        <FormStepWLS
          setQuoteSummaryData={setQuoteSummaryData}
          stepData={stepData}
          steps={steps}
          progressBarSteps={progressBarSteps}
          step={step}
          updateStep={updateStep}
          history={history}
          orderData={orderData}
          onSaveAndExit={onSaveAndExit}
          onViewPdf={viewPDF}
          onFormSubmit={onWlsFormSubmit}
          setFormRef={setFormRef}
          hideProgressBar={hideProgressBar}
          setOrderData={setOrderData}
          isEditing={isEditing}
          formName={formName}
          onSaveAndContinue={onSaveAndContinue}
          onCreateNewOrder={onCreateNewOrder}
          isCreateOrderVisible={isCreateOrderVisible}
        />
      );
    if (categoryName === categoryFullyManaged)
      return (
        <FormStepFM
          setQuoteSummaryData={setQuoteSummaryData}
          stepData={stepData}
          steps={steps}
          progressBarSteps={progressBarSteps}
          step={step}
          updateStep={updateStep}
          history={history}
          orderData={orderData}
          onSaveAndExit={onSaveAndExit}
          onViewPdf={viewPDF}
          onFormSubmit={onFMFormSubmit}
          setFormRef={setFormRef}
          hideProgressBar={hideProgressBar}
          setOrderData={setOrderData}
          isEditing={isEditing}
          formName={formName}
          onSaveAndContinue={onSaveAndContinue}
          onCreateNewOrder={onCreateNewOrder}
          isCreateOrderVisible={isCreateOrderVisible}
        />
      );

    if (categoryName === categoryVulcan)
      return (
        <FormStepVulcan
          setQuoteSummaryData={setQuoteSummaryData}
          stepData={stepData}
          steps={steps}
          progressBarSteps={progressBarSteps}
          step={step}
          updateStep={updateStep}
          history={history}
          orderData={orderData}
          onSaveAndExit={onSaveAndExit}
          onViewPdf={viewPDF}
          onFormSubmit={onVulcanFormSubmit}
          setFormRef={setFormRef}
          hideProgressBar={hideProgressBar}
          setOrderData={setOrderData}
          isEditing={isEditing}
          formName={formName}
          onSaveAndContinue={onSaveAndContinue}
          onCreateNewOrder={onCreateNewOrder}
          isCreateOrderVisible={isCreateOrderVisible}
          isCreateOrderButtonVisible={setIsCreateOrderButtonVisible}
          stepDataForSummary={dataSummary.fields.steps[step - 1]}
        />
      );
    if (categoryName === categoryFullyManagedSOW)
      return (
        <FormStepFMSOW
          setQuoteSummaryData={setQuoteSummaryData}
          stepData={stepData}
          steps={steps}
          progressBarSteps={progressBarSteps}
          step={step}
          updateStep={updateStep}
          history={history}
          orderData={orderData}
          onSaveAndExit={onSaveAndExit}
          onFormSubmit={onFMFormSubmitSOW}
          setFormRef={setFormRef}
          hideProgressBar={hideProgressBar}
          setOrderData={setOrderData}
          isEditing={isEditing}
          formName={formName}
          onSaveAndContinue={onSaveAndContinue}
          onCreateNewOrder={onCreateNewOrder}
          isCreateOrderVisible={isCreateOrderVisible}
        />
      );
    if (categoryName === categoryOCDR)
      return (
        <FormStepOCDR
          setQuoteSummaryData={setQuoteSummaryData}
          stepData={stepData}
          steps={steps}
          progressBarSteps={progressBarSteps}
          step={step}
          updateStep={updateStep}
          history={history}
          orderData={orderData}
          onSaveAndExit={onSaveAndExit}
          onViewPdf={viewPDF}
          onFormSubmit={onOCDRFormSubmit}
          setFormRef={setFormRef}
          hideProgressBar={hideProgressBar}
          setOrderData={setOrderData}
          isEditing={isEditing}
          formName={formName}
          onSaveAndContinue={onSaveAndContinue}
          onCreateNewOrder={onCreateNewOrder}
          isCreateOrderVisible={isCreateOrderVisible}
          isCreateOrderButtonVisible={setIsCreateOrderButtonVisible}
        />
      );
    return (
      <FormStep
        setQuoteSummaryData={setQuoteSummaryData}
        stepData={stepData}
        steps={steps}
        progressBarSteps={progressBarSteps}
        updateProgressBarSteps={updateProgressBarSteps}
        step={step}
        updateStep={updateStep}
        history={history}
        orderData={orderData}
        onSaveAndExit={onSaveAndExit}
        onViewPdf={viewPDF}
        onFormSubmit={onFormSubmit}
        setFormRef={setFormRef}
        hideProgressBar={hideProgressBar}
        setOrderData={setOrderData}
        isEditing={isEditing}
        formName={formName}
        onSaveAndContinue={onSaveAndContinue}
        onCreateNewOrder={onCreateNewOrder}
        isCreateOrderVisible={isCreateOrderVisible}
        isCreateOrderButtonVisible={setIsCreateOrderButtonVisible}
      />
    );
  };

  const handleActiveTab = id => {
    setActiveTab(id);
    if (id === 'MyOrders') {
      const SrtPage = localStorage.getItem('SrtPage')
        ? localStorage.getItem('SrtPage')
        : 1;
      history.push({
        pathname: `/${locale}/${categoryName}/${landingPageForm}`,
        search: `?page=${SrtPage}`
      });
    } else if (id === 'OrderFulfillmentDashboard') {
      const OrderFulfillmentPage = localStorage.getItem('OrderFulfillmentPage')
        ? localStorage.getItem('OrderFulfillmentPage')
        : 1;
      history.push({
        pathname: `/${locale}/${categoryName}/${landingPageForm}`,
        search: `?page=${OrderFulfillmentPage}`
      });
    }
  };

  const handleActiveTabVUL = id => {
    setActiveTab(id);
    if (id === 'MyOrders') {
      const myOrderPage = localStorage.getItem('myOrderVULPage')
        ? localStorage.getItem('myOrderVULPage')
        : 1;
      history.push({
        pathname: `/${locale}/${categoryName}/${vulcanLandingPage}`,
        search: `?page=${myOrderPage}`
      });
    } else if (id === 'OrderFulfillmentDashboard') {
      const OrderFulfillmentVULPage = localStorage.getItem(
        'OrderFulfillmentVLUPage'
      )
        ? localStorage.getItem('OrderFulfillmentVULPage')
        : 1;
      history.push({
        pathname: `/${locale}/${categoryName}/${vulcanLandingPage}`,
        search: `?page=${OrderFulfillmentVULPage}`
      });
    }
  };

  const handleHistoryPush = pageNumber => {
    history.push({
      pathname: `/${locale}/${categoryName}/${wirelessLandingPageForm}`,
      search: `?page=${pageNumber}`
    });
  };

  const handleActiveWLSTab = id => {
    setActiveTab(id);
    if (id === 'MyOrders') {
      const MyOrdersPageWLS = localStorage.getItem('MyOrdersPageWLS')
        ? localStorage.getItem('MyOrdersPageWLS')
        : 1;
      history.push({
        pathname: `/${locale}/${categoryName}/${wirelessLandingPageForm}`,
        search: `?page=${MyOrdersPageWLS}`
      });
    } else if (id === 'AllOrders') {
      const AllOrdersPageWLS = localStorage.getItem('AllOrdersPageWLS')
        ? localStorage.getItem('AllOrdersPageWLS')
        : 1;
      history.push({
        pathname: `/${locale}/${categoryName}/${wirelessLandingPageForm}`,
        search: `?page=${AllOrdersPageWLS}`
      });
    } else if (id === 'ManageDevices') {
      const ManageDevices = localStorage.getItem('ManageDevices')
        ? localStorage.getItem('ManageDevices')
        : 1;
      history.push({
        pathname: `/${locale}/${categoryName}/${wirelessLandingPageForm}`,
        search: `?page=${ManageDevices}`
      });
    } else if (id === 'ChannelOrders') {
      const ChannelOrdersPageWLS = localStorage.getItem('ChannelOrdersPageWLS')
        ? localStorage.getItem('ChannelOrdersPageWLS')
        : 1;
      history.push({
        pathname: `/${locale}/${categoryName}/${wirelessLandingPageForm}`,
        search: `?page=${ChannelOrdersPageWLS}`
      });
    }
  };

  const handleActiveFMTab = id => {
    setActiveTab(id);
    if (id === 'MyOrders') {
      const myOrderPage = localStorage.getItem('myOrderPageNo')
        ? localStorage.getItem('myOrderPageNo')
        : 1;
      history.push({
        pathname: `/${locale}/${categoryName}/${fullyManagedLandingPage}`,
        search: `?page=${myOrderPage}`
      });
    } else if (id === 'OrderFulfillmentDashboard') {
      const OrderFulfillmentPage = localStorage.getItem('OrderFulfillmentPage')
        ? localStorage.getItem('OrderFulfillmentPage')
        : 1;
      history.push({
        pathname: `/${locale}/${categoryName}/${fullyManagedLandingPage}`,
        search: `?page=${OrderFulfillmentPage}`
      });
    } else if (id === 'DiscountApprovalDashboard') {
      const DiscountApprovalPage = localStorage.getItem('discountOrderPageNo')
      ? localStorage.getItem('discountOrderPageNo')
      : 1;
    history.push({
      pathname: `/${locale}/${categoryName}/${fullyManagedLandingPage}`,
      search: `?page=${DiscountApprovalPage}`
    });
    }
  };

  const handleActiveOCDRTab = id => {
    setActiveTab(id);
    if (id === 'MyOrders') {
      const myOrderPage = localStorage.getItem('myOrderPageNo')
        ? localStorage.getItem('myOrderPageNo')
        : 1;
      history.push({
        pathname: `/${locale}/${categoryName}/${ocdrLandingPage}`,
        search: `?page=${myOrderPage}`
      });
    } else if (id === 'OrderFulfillmentDashboard') {
      const OrderFulfillmentPage = localStorage.getItem('OrderFulfillmentPage')
        ? localStorage.getItem('OrderFulfillmentPage')
        : 1;
      history.push({
        pathname: `/${locale}/${categoryName}/${ocdrLandingPage}`,
        search: `?page=${OrderFulfillmentPage}`
      });
    }
  };  

  const handleActiveFMSOWTab = id => {
    setActiveTab(id);
    if (id === 'MyOrders') {
      const myOrderPage = localStorage.getItem('myOrderPageNo')
        ? localStorage.getItem('myOrderPageNo')
        : 1;
      history.push({
        pathname: `/${locale}/${categoryName}/${fullyManagedSOWLandingPage}`,
        search: `?page=${myOrderPage}`
      });
    } else if (id === 'OrderFulfillmentDashboard') {
      const OrderFulfillmentPage = localStorage.getItem('OrderFulfillmentPage')
        ? localStorage.getItem('OrderFulfillmentPage')
        : 1;
      history.push({
        pathname: `/${locale}/${categoryName}/${fullyManagedSOWLandingPage}`,
        search: `?page=${OrderFulfillmentPage}`
      });
    }
  };

  const getAdminTabs = currentlyActiveTab => {
    if (currentlyActiveTab === 'MyOrders')
      return (
        <SalesRepDashboard
          id="MyOrders"
          handleHistoryPush={handleHistoryPush}
          history={history}
          userId={userProfile.id}
        />
      );
    if (currentlyActiveTab === 'AllOrders')
      return (
        <AllOrdersDashboardWLS
          id="AllOrders"
          handleHistoryPush={handleHistoryPush}
          history={history}
        />
      );
    return <HardwareGridUpload />;
  };

  const showWLSTabs = () => {
    if (roleName === 'ADMIN')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveWLSTab}>
            <Tabs.Panel id="MyOrders" heading={MyOrders} />
            <Tabs.Panel id="AllOrders" heading={AllOrders} />
            <Tabs.Panel id="ManageDevices" heading={ManageDevicesCreditsFee} />
          </Tabs>
          {getAdminTabs(activeTab)}
        </>
      );

    if (roleName === 'SALES_REP')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveWLSTab}>
            <Tabs.Panel id="MyOrders" heading={MyOrders} />
            <Tabs.Panel id="empty" heading="" />
          </Tabs>
          <SalesRepDashboard
            handleHistoryPush={handleHistoryPush}
            history={history}
            userId={userProfile.id}
          />
        </>
      );

    if (roleName === 'SALES_SUPPORT')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveWLSTab}>
            <Tabs.Panel id="ChannelOrders" heading={ChannelOrders} />
            <Tabs.Panel id="empty" heading="" style={{ marginLeft: 20 }} />
          </Tabs>
          <ChannelOrdersDashboardWLS handleHistoryPush={handleHistoryPush} />
        </>
      );

    if (roleName === 'SALES_MANAGER')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveWLSTab}>
            <Tabs.Panel id="MyOrders" heading={MyOrders} />
            <Tabs.Panel id="ChannelOrders" heading={ChannelOrders} />
          </Tabs>
          {activeTab === 'MyOrders' ? (
            <SalesRepDashboard
              handleHistoryPush={handleHistoryPush}
              history={history}
              roleName={roleName}
              userId={userProfile.id}
            />
          ) : (
            <ChannelOrdersDashboardWLS handleHistoryPush={handleHistoryPush} />
          )}
        </>
      );
    return null;
  };

  const showVulcanTabs = () => {
    if (roleName === 'ADMIN' || roleName === 'SALES_MANAGER')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveTabVUL}>
            <Tabs.Panel id="MyOrders" heading={myOrderHeader} />
            <Tabs.Panel
              id="OrderFulfillmentDashboard"
              heading={orderFulfilmentHeader}
            />
          </Tabs>
          {activeTab === 'MyOrders' ? (
            <MyOrdersDashboardVUL
              location={history.location}
              userId={userProfile.id}
            />
          ) : (
            <OrderFulfillmentDashboardVUL location={history.location} />
          )}
        </>
      );
    if (roleName === 'SALES_REP')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveTabVUL}>
            <Tabs.Panel id="MyOrders" heading={myOrderHeader} />
            <Tabs.Panel id="empty" heading="" />
          </Tabs>
          <MyOrdersDashboardVUL location={history.location} />
        </>
      );
    if (roleName === 'ORDER_FULFILLMENT' || roleName === 'SALES_SUPPORT')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveTabVUL}>
            <Tabs.Panel
              id="OrderFulfillmentDashboard"
              heading={orderFulfilmentHeader}
            />
            <Tabs.Panel id="empty" heading="" style={{ marginLeft: 20 }} />
          </Tabs>
          <OrderFulfillmentDashboardVUL location={history.location} />
        </>
      );
    return null;
  };

  const showOCDRTabs = () => {
    if (roleName === 'ADMIN')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveOCDRTab}>
            <Tabs.Panel id="MyOrders" heading="My Orders" />
            <Tabs.Panel
              id="OrderFulfillmentDashboard"
              heading="Order Fulfillment Dashboard"
            />
          </Tabs>
          {activeTab === 'MyOrders' ? (
            <MyOrdersDashboardOCDR
              location={history.location}
              userId={userProfile.id}
            />
          ) : (
            <OrderFulfillmentDashboardOCDR location={history.location} />
          )}
        </>
      );
    if (roleName === 'SALES_REP')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveOCDRTab}>
            <Tabs.Panel id="MyOrders" heading="My Orders" />
            <Tabs.Panel id="empty" heading="" />
          </Tabs>
          <MyOrdersDashboardOCDR
            location={history.location}
            userId={userProfile.id}
          />
        </>
      );
    if (roleName === 'SALES_MANAGER' || roleName === 'SALES_SUPPORT')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveOCDRTab}>
            <Tabs.Panel
              id="OrderFulfillmentDashboard"
              heading="Order Fulfillment Dashboard"
            />
            <Tabs.Panel id="empty" heading="" style={{ marginLeft: 20 }} />
          </Tabs>
          <OrderFulfillmentDashboardOCDR location={history.location} />
        </>
      );
    return null;
  };

  const showFMTabs = () => {
    if (roleName === 'ADMIN')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveFMTab}>
            <Tabs.Panel id="MyOrders" heading="My Orders" />
            <Tabs.Panel
              id="OrderFulfillmentDashboard"
              heading="Order Fulfillment Dashboard"
            />
            <Tabs.Panel
              id="DiscountApprovalDashboard"
              heading="Discount Approval Dashboard"
            />
          </Tabs>
          {activeTab === 'MyOrders' ? (
            <MyOrdersDashboardFM
              location={history.location}
              userId={userProfile.id}
            />
          ) : activeTab === 'OrderFulfillmentDashboard' ? (
            <OrderFulfillmentDashboardFM location={history.location} />
          ) : (
            <DiscountApprovalDashboardFM location={history.location} selectedDiscount={selectedDiscount}/>
          )}
        </>
      );
    if (roleName === 'SALES_REP')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveFMTab}>
            <Tabs.Panel id="MyOrders" heading="My Orders" />
            <Tabs.Panel id="empty" heading="" />
          </Tabs>
          <MyOrdersDashboardFM
            location={history.location}
            userId={userProfile.id}
          />
        </>
      );
    if (roleName === 'SALES_MANAGER' || roleName === 'SALES_SUPPORT')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveFMTab}>
            <Tabs.Panel
              id="OrderFulfillmentDashboard"
              heading="Order Fulfillment Dashboard"
            />
            <Tabs.Panel id="empty" heading="" style={{ marginLeft: 20 }} />
          </Tabs>
          <OrderFulfillmentDashboardFM location={history.location} />
        </>
      );
    if (roleName === 'PROPOSAL_HOUSE')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveFMTab}>
            <Tabs.Panel
              id="DiscountApprovalDashboard"
              heading="Discount Approval Dashboard"
            />
            <Tabs.Panel id="empty" heading="" style={{ marginLeft: 20 }} />
          </Tabs>
          <DiscountApprovalDashboardFM location={history.location} />
        </>
      );

    return null;
  };

  const showFMSOWTabs = () => {
    if (emailForSOW.includes(email)) {
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveFMSOWTab}>
            <Tabs.Panel
              id="OrderFulfillmentDashboard"
              heading="Order Fulfillment Dashboard"
            />
            <Tabs.Panel id="empty" heading="" />
          </Tabs>
          <OrderFulfillmentDashboardFMSOW
            location={history.location}
            userId={userProfile.id}
          />
        </>
      );
    }
    if (roleName === 'ADMIN')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveFMSOWTab}>
            <Tabs.Panel id="MyOrders" heading="My Orders" />
            <Tabs.Panel
              id="OrderFulfillmentDashboard"
              heading="Order Fulfillment Dashboard"
            />
          </Tabs>
          {activeTab === 'MyOrders' ? (
            <MyOrdersDashboardFMSOW
              location={history.location}
              userId={userProfile.id}
            />
          ) : (
            <OrderFulfillmentDashboardFMSOW location={history.location} />
          )}
        </>
      );
    if (roleName === 'SALES_REP')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveFMSOWTab}>
            <Tabs.Panel id="MyOrders" heading="My Orders" />
            <Tabs.Panel id="empty" heading="" />
          </Tabs>
          <MyOrdersDashboardFMSOW
            location={history.location}
            userId={userProfile.id}
          />
        </>
      );
    if (
      roleName === 'SALES_MANAGER' ||
      roleName === 'SALES_SUPPORT' ||
      roleName === 'ORDER_FULFILLMENT'
    )
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveFMSOWTab}>
            <Tabs.Panel
              id="OrderFulfillmentDashboard"
              heading="Order Fulfillment Dashboard"
            />
            <Tabs.Panel id="empty" heading="" />
          </Tabs>
          <OrderFulfillmentDashboardFMSOW
            location={history.location}
            userId={userProfile.id}
          />
        </>
      );
    return null;
  };

  const showTabs = () => {
    if (roleName === 'ADMIN' || roleName === 'SALES_MANAGER')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveTab}>
            <Tabs.Panel id="MyOrders" heading="My Orders" />
            <Tabs.Panel
              id="OrderFulfillmentDashboard"
              heading="Order Fulfillment Dashboard"
            />
          </Tabs>
          {activeTab === 'MyOrders' ? (
            <SrtDashboard location={history.location} />
          ) : (
            <OrderFulfillmentDashboard location={history.location} />
          )}
        </>
      );
    if (roleName === 'SALES_REP')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveTab}>
            <Tabs.Panel id="MyOrders" heading="My Orders" />
            <Tabs.Panel id="empty" heading="" />
          </Tabs>
          <SrtDashboard location={history.location} />
        </>
      );
    if (roleName === 'ORDER_FULFILLMENT' || roleName === 'SALES_SUPPORT')
      return (
        <>
          <Tabs copy="en" open={activeTab} onOpen={handleActiveTab}>
            <Tabs.Panel
              id="OrderFulfillmentDashboard"
              heading="Order Fulfillment Dashboard"
            />
            <Tabs.Panel id="empty" heading="" style={{ marginLeft: 20 }} />
          </Tabs>
          <OrderFulfillmentDashboard location={history.location} />
        </>
      );
    return null;
  };

  const getCategoryLabel = catgName => {
    if (catgName === categoryWireless) return TELUSWirelessSalesOrderForm;
    if (catgName === categoryWireline) return WirelineandSecureBusiness;
    return '';
  };

  if (step > 0 && !hideProgressBar) return <>{getFormStep()}</>;

  const categoryFormMap = {
    [categoryWireless]: showWLSTabs,
    [categoryFullyManaged]: showFMTabs,
    [categoryVulcan]: showVulcanTabs,
    [categoryFullyManagedSOW]: showFMSOWTabs,
    [categoryOCDR]: showOCDRTabs,
    [categoryWireline]: showTabs
  };

  return (
    <>
      <div>
        <h2
          style={{
            fontSize: '2.75rem',
            color: 'rgb(75, 40, 109)',
            fontWeight: '300',
            letterSpacing: '0px',
            marginLeft: '6%',
            marginTop: '2%'
          }}
        >
          {getCategoryLabel(categoryName)}
        </h2>
      </div>
      <div>
        <div className="container 85%">
          <div id="title">
            <div id="title-wrapper">
              <div>
                <h2>
                  <RichText data={description} />
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container 85%">
        <div id="introduction">
          <div id="introduction-wrapper">
            <FormWrapper>
              <div className={image && 'column'}>
                {hideProgressBar && <>{getFormStep()}</>}
              </div>
              {image && (
                <div className="column image">
                  <Image image={image} />
                </div>
              )}
              {step === 1 &&
                showOrdersList &&
                roleName !== 'SALES_SUPPORT' &&
                showQuoteButton() && (
                  <button
                    type="button"
                    onClick={e => onClick(e)}
                    className="frg-button color-green"
                    style={{ marginBottom: '1em' }}
                    disabled={isCreateOrderButtonVisible}
                  >
                    {[
                      categoryWireless,
                      categoryFullyManaged,
                      categoryFullyManagedSOW,
                      categoryOCDR,
                      categoryVulcan
                    ].includes(categoryName)
                      ? newOrderButtonLabel
                      : newQuoteButtonLabel}
                  </button>
                )}
            </FormWrapper>
          </div>
        </div>
      </div>
      {steps && steps.length > 1 && !skipIntro && (
        <div className="container 85%" style={{ paddingBottom: '3rem' }}>
          <span>
            <a
              href="/"
              onClick={e => onClick(e)}
              className="frg-button color-green"
            >
              {categoryName === categoryWireless ||
              categoryName === categoryFullyManaged ||
              categoryName === categoryFullyManagedSOW ||
              categoryName === categoryOCDR ||
              categoryName === categoryVulcan
                ? newOrderButtonLabel
                : newQuoteButtonLabel}
            </a>
          </span>
        </div>
      )}
      {step === 1 && showOrdersList && <>{categoryFormMap[categoryName]()}</>}
    </>
  );
};

Form.propTypes = {
  data: PropTypes.shape({
    fields: PropTypes.objectOf(PropTypes.object)
  }).isRequired,
  orderId: PropTypes.string,
  initialStep: PropTypes.string,
  isEditing: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func,
    location: PropTypes.shape({
      pathname: PropTypes.string
    })
  }).isRequired
};

Form.defaultProps = {
  orderId: '',
  initialStep: '',
  isEditing: ''
};

export default Form;
